var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('sui-dimmer',{attrs:{"active":this.$store.state.loading}},[_c('sui-loader',[_vm._v("Veuilez patienter...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }